import OpenX from '@module/openx';
import Store from '@app/store';

const { session, user } = Store.getState();

OpenX.setLoggedIn(user.loggedIn);

OpenX.configure({
  // Determine in what region we'll show adverts
  continent: session.region.continent,
  country: session.region.country,

  // Set the timeout for jsonp requests
  timeout: 5000,

  // Configure real and fallback endpoints
  endpoints: {
    openx: 'https://wetransfer-d.openx.net/w/1.0/arj',
    fallback: 'https://wtplus.wetransfer.com',
  },

  // Configure ad units (and timers)
  adunits: [
    {
      country: 'AU',
      positions: {
        '1': '159791',
        '2': '159792',
        '3': '159793',
        '4': '159794',
        '5': '159795',
        '6': '159798',
        '7': '159796',
        '8': '159797',
        '9': '159800',
        '10': '159801',
        '11': '538679603',
        '12': '538679602',
        '13': '538679604',
        '14': '538679605',
        '15': '538679606',
        '16...25': '538679608',
        '*': '343338',
      },
    },
    {
      country: 'BE',
      positions: {
        '1': '160247',
        '2': '160249',
        '3': '160250',
        '4': '160251',
        '5': '160252',
        '6': '160253',
        '7': '160254',
        '8': '160255',
        '9': '160256',
        '10': '160257',
        '11...25': '343359',
        '*': '343360',
      },
      timers: {
        '1...10': 45000,
      },
    },
    {
      country: 'FR',
      positions: {
        '1': '160264',
        '2': '160265',
        '3': '160266',
        '4': '160267',
        '5': '160268',
        '6': '160259',
        '7': '160260',
        '8': '160261',
        '9': '160262',
        '10': '160263',
        '11': '538768042',
        '12': '538768043',
        '13': '538768044',
        '14': '538768045',
        '15': '538768046',
        '16...25': '538768047',
        '*': '343362',
      },
      timers: {
        '1...10': 45000,
      },
    },
    {
      country: 'DE',
      positions: {
        '1': '159869',
        '2': '159870',
        '3': '159871',
        '4': '159872',
        '5': '159873',
        '6': '159874',
        '7': '159875',
        '8': '159876',
        '9': '159877',
        '10': '159878',
        '11': '539513848',
        '12': '539513864',
        '13': '539513863',
        '14': '539513862',
        '15': '539513860',
        '16...25': '343339',
        '*': '343340',
      },
      timers: {
        '1...10': 30000,
      },
    },
    {
      country: 'GR',
      positions: {
        '1': '538679654',
        '2': '538679658',
        '3': '538679659',
        '4': '538679660',
        '5': '538679661',
        '6': '538679662',
        '7': '538679665',
        '8': '538679668',
        '9': '538679667',
        '10': '538679666',
        '11': '538679669',
        '12': '538679670',
        '13': '538679671',
        '14': '538679672',
        '15': '538679673',
        '16...25': '538679678',
        '*': '538679679',
      },
    },
    {
      country: 'HK',
      positions: {
        '1': '159880',
        '2': '159881',
        '3': '159882',
        '4': '159883',
        '5': '159884',
        '6': '159886',
        '7': '159887',
        '8': '159888',
        '9': '159890',
        '10': '159891',
        '11...25': '343341',
        '*': '343342',
      },
    },
    {
      country: 'IT',
      positions: {
        '1': '160270',
        '2': '160271',
        '3': '160272',
        '4': '160273',
        '5': '160274',
        '6': '160275',
        '7': '160276',
        '8': '160277',
        '9': '160278',
        '10': '160279',
        '11...25': '343363',
        '*': '343364',
      },
      timers: {
        '1...10': 45000,
      },
    },
    {
      country: 'NL',
      positions: {
        '1': '159894',
        '2': '159895',
        '3': '159896',
        '4': '159897',
        '5': '159898',
        '6': '159899',
        '7': '159900',
        '8': '159901',
        '9': '159902',
        '10': '159903',
        '11': '538464017',
        '12': '538464019',
        '13': '538464018',
        '14': '538464020',
        '15': '538464021',
        '16...25': '343343',
        '*': '343344',
      },
      timers: {
        '1...10': 45000,
      },
    },
    {
      country: 'PT',
      positions: {
        '1': '160286',
        '2': '160287',
        '3': '160288',
        '4': '160289',
        '5': '160290',
        '6': '160281',
        '7': '160282',
        '8': '160283',
        '9': '160284',
        '10': '160285',
        '11...25': '343365',
        '*': '343366',
      },
      timers: {
        '1...10': 45000,
      },
    },
    {
      country: 'SG',
      positions: {
        '1': '160125',
        '2': '160126',
        '3': '160127',
        '4': '160128',
        '5': '160129',
        '6': '160130',
        '7': '160131',
        '8': '160132',
        '9': '160133',
        '10': '160134',
        '11...25': '343345',
        '*': '343346',
      },
    },
    {
      country: 'ES',
      positions: {
        '1': '160292',
        '2': '160293',
        '3': '160294',
        '4': '160295',
        '5': '160296',
        '6': '160297',
        '7': '160298',
        '8': '160299',
        '9': '160300',
        '10': '160301',
        '11...25': '343367',
        '*': '343368',
      },
      timers: {
        '1...10': 45000,
      },
    },
    {
      country: 'GB',
      positions: {
        '1': '160136',
        '2': '160137',
        '3': '160138',
        '4': '160139',
        '5': '160140',
        '6': '160141',
        '7': '160142',
        '8': '160143',
        '9': '160144',
        '10': '160145',
        '11...25': '343347',
        '*': '343348',
      },
      timers: {
        '1...10': 45000,
      },
    },
    {
      country: 'IE',
      positions: {
        '1': '397207',
        '2': '397208',
        '3': '397210',
        '4': '397212',
        '5': '397213',
        '6': '397215',
        '7': '397216',
        '8': '397218',
        '9': '397220',
        '10': '397221',
        '11...25': '397222',
        '*': '397223',
      },
    },
    {
      country: 'TR',
      positions: {
        '1': '246033',
        '2': '246034',
        '3': '246040',
        '4': '246042',
        '5': '246043',
        '6': '246044',
        '7': '246045',
        '8': '246046',
        '9': '246047',
        '10': '246048',
        '11...25': '343377',
        '*': '343378',
      },
    },
    {
      country: 'RU',
      positions: {
        '1': '545037',
        '2': '545038',
        '3': '545039',
        '4': '545040',
        '5': '545041',
        '6': '545042',
        '7': '545043',
        '8': '545044',
        '9': '545045',
        '10': '545046',
        '11...25': '545047',
        '*': '545048',
      },
    },
    {
      country: 'CA',
      positions: {
        '1': '537190900',
        '2': '537190901',
        '3': '537190902',
        '4': '537190903',
        '5': '537190904',
        '6': '537190906',
        '7': '537190909',
        '8': '537190910',
        '9': '537190911',
        '10': '537190912',
        '11...25': '537190915',
        '*': '537190916',
      },
    },
    {
      country: 'US',
      positions: {
        '1': '537191786',
        '2': '537191787',
        '3': '537191788',
        '4': '537191790',
        '5': '537191791',
        '6': '537191792',
        '7': '537191793',
        '8': '537191794',
        '9': '537191795',
        '10': '537191796',
        '11': '538418325',
        '12': '538418326',
        '13': '538418327',
        '14': '538418328',
        '15': '538418329',
        '16...25': '538418330',
        '*': '537191798',
      },
      timers: {
        '1...10': 45000,
      },
    },
    {
      country: 'BR',
      positions: {
        '1': '537191801',
        '2': '537191802',
        '3': '537191803',
        '4': '537191804',
        '5': '537191806',
        '6': '537191807',
        '7': '537191808',
        '8': '537191809',
        '9': '537191810',
        '10': '537191811',
        '11...25': '537191813',
        '*': '537191815',
      },
      timers: {
        '1...10': 45000,
      },
    },
    {
      country: 'MX',
      positions: {
        '1': '537190877',
        '2': '537190878',
        '3': '537190879',
        '4': '537190881',
        '5': '537190884',
        '6': '537190886',
        '7': '537190887',
        '8': '537190888',
        '9': '537190891',
        '10': '537190992',
        '11...25': '537190893',
        '*': '537190895',
      },
      timers: {
        '1...10': 45000,
      },
    },
    {
      country: 'IN',
      positions: {
        '1': '538140845',
        '2': '538140846',
        '3': '538140847',
        '4': '538140848',
        '5': '538140849',
        '6': '538140850',
        '7': '538140851',
        '8': '538140852',
        '9': '538140853',
        '10': '538140854',
        '11...25': '538140855',
        '*': '538140856',
      },
    },
    {
      country: 'ZA',
      positions: '*',
      timers: {
        '1...10': 45000,
      },
    },
    {
      country: 'RO',
      positions: {
        '1': '539379463',
        '2': '539379471',
        '3': '539379470',
        '4': '539379469',
        '5': '539379468',
        '6': '539379467',
        '7': '539379473',
        '8': '539379475',
        '9': '539379476',
        '10': '539379477',
        '11': '539379478',
        '12': '539379479',
        '13': '539379480',
        '14': '539379484',
        '15': '539379487',
        '16...25': '539379492',
        '*': '539379491',
      },
      timers: {
        '1...10': 45000,
      },
    },
    {
      country: 'SA',
      positions: '*',
      timers: {
        '1...10': 45000,
      },
    },
    {
      country: 'AE',
      positions: '*',
      timers: {
        '1...10': 45000,
      },
    },
    {
      continent: 'EU',
      positions: {
        '1': '160196',
        '2': '160197',
        '3': '160198',
        '4': '160199',
        '5': '160200',
        '6': '160191',
        '7': '160192',
        '8': '160193',
        '9': '160194',
        '10': '160195',
        '11...25': '343357',
        '*': '343358',
      },
    },
    {
      continent: 'NA',
      positions: {
        '1': '160220',
        '2': '160221',
        '3': '160222',
        '4': '160223',
        '5': '160224',
        '6': '160215',
        '7': '160216',
        '8': '160217',
        '9': '160218',
        '10': '160219',
        '11...25': '343371',
        '*': '343372',
      },
    },
    {
      continent: 'AS',
      positions: {
        '1': '160158',
        '2': '160159',
        '3': '160160',
        '4': '160161',
        '5': '160162',
        '6': '160163',
        '7': '160164',
        '8': '160165',
        '9': '160166',
        '10': '160167',
        '11...25': '343351',
        '*': '343352',
      },
    },
    {
      continent: 'SA',
      positions: {
        '1': '160242',
        '2': '160243',
        '3': '160244',
        '4': '160245',
        '5': '160246',
        '6': '160237',
        '7': '160238',
        '8': '160239',
        '9': '160240',
        '10': '160241',
        '11...25': '343375',
        '*': '343376',
      },
    },
    {
      continent: 'OC',
      positions: {
        '1': '160226',
        '2': '160227',
        '3': '160228',
        '4': '160229',
        '5': '160230',
        '6': '160231',
        '7': '160233',
        '8': '160232',
        '9': '160234',
        '10': '160235',
        '11...25': '343373',
        '*': '343374',
      },
    },
    {
      continent: 'AF',
      positions: {
        '1': '160152',
        '2': '160153',
        '3': '160154',
        '4': '160155',
        '5': '160156',
        '6': '160147',
        '7': '160148',
        '8': '160149',
        '9': '160150',
        '10': '160151',
        '11...25': '343349',
        '*': '343350',
      },
    },
    {
      country: '*',
      positions: {
        '1...3': '92027',
        '4...10': '92040',
        '11...25': '343379',
        '*': '343380',
      },
      timers: {
        '1...10': 60000,
        '11...25': 180000,
        '*': 600000,
      },
    },
  ],
});
